export default "__VITE_ASSET__KBwhRCl9__"